module.exports = __webpack_public_path__ + "img/43_26.dbf05c42.png";